var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51.459,
    viewBox: "0 0 50 51.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.999 -443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.999 443)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6500.062-785.894l-12.944-12.947,5.294-5.292,7.65,7.652,7.652-7.652,5.294,5.292Z",
    transform: "translate(6525.061 817.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6492.316-786.724h-7.485V-798.51a6.944,6.944,0,0,0-6.936-6.937h-14.319v-7.485h14.319a14.438,14.438,0,0,1,14.421,14.423Z",
    transform: "translate(6521.057 812.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-6471.057-765.825h-50V-804.18h7.485v30.87h35.029v-30.87h7.485Z",
    transform: "translate(6521.057 817.284)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkIcon);
export default __webpack_public_path__ + "static/media/park_icon.841ddd3168d38a12331f265d04535fae.svg";
export { ForwardRef as ReactComponent };